// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3_xO5_-dQCpjG5rIU03sQW {\n  opacity: 0.01;\n}\n\n.lteMrKEKR0JPpuh-1MGWJ {\n  opacity: 1;\n  transition: opacity 300ms ease-in;\n}\n\n.RwvUiOzeKh3aEwvmCy1jY {\n  opacity: 1;\n}\n\n.awBjAqLiGnZYxYHlcgZJn {\n  opacity: 0.01;\n  transition: opacity 700ms ease-in;\n}\n\n._3qXEPFZiaDwfuDqIJZB2IS {\n  opacity: 0.01;\n}\n\n._2cn-TFyG1IewlMZZ3bgvKx {\n  opacity: 1;\n  transition: opacity 500ms ease-in;\n}\n\n.maPK8uzily2KwC90mYrE6 {\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  z-index: 1000000;\n}\n\n@media (min-width: 768px) {\n  .maPK8uzily2KwC90mYrE6 {\n    top: 50px;\n    right: 3em;\n    left: auto;\n    max-width: 30%;\n  }\n}\n\n._2T-cRIzpz8athVEFwyPuZf {\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n\n.-AziBai2ohN72IPTtZ2tm > h4 > i {\n  margin: 0 0.5em 0 0;\n}\n\n._2LqxYKOObL1DHpQL3aaSAt {\n  margin: 0.5em 0;\n}\n", ""]);
// Exports
exports.locals = {
	"enter": "_3_xO5_-dQCpjG5rIU03sQW",
	"enterActive": "lteMrKEKR0JPpuh-1MGWJ",
	"leave": "RwvUiOzeKh3aEwvmCy1jY",
	"leaveActive": "awBjAqLiGnZYxYHlcgZJn",
	"appear": "_3qXEPFZiaDwfuDqIJZB2IS",
	"appearActive": "_2cn-TFyG1IewlMZZ3bgvKx",
	"container": "maPK8uzily2KwC90mYrE6",
	"borders": "_2T-cRIzpz8athVEFwyPuZf",
	"notificationHeader": "-AziBai2ohN72IPTtZ2tm",
	"notificationBody": "_2LqxYKOObL1DHpQL3aaSAt"
};
module.exports = exports;
